import script from "./MultiStylePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./MultiStylePanel.vue?vue&type=script&lang=ts&setup=true"

import "./MultiStylePanel.vue?vue&type=style&index=0&id=78fc4809&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78fc4809"]])

export default __exports__